import fetchIntercept from 'fetch-intercept';

export const registerFetchInterceptor = (start, finish) =>
  fetchIntercept.register({
    request(url, config) {
      start();
      return [url, config];
    },

    requestError(error) {
      finish();
      return Promise.reject(error);
    },

    response(response) {
      finish();
      return response;
    },

    responseError(error) {
      finish();
      return Promise.reject(error);
    },
  });
